
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { CartContext } from "../../providers/cart";


export const Cart = () => {
 


  const {cart, cartRemove, cartDecrement} = useContext(CartContext)

  const history = useHistory();

  const removeProduct = (product) => {
    cartRemove(product);
  };

  return (
    <div className="main_content">
      <h3>
          Sua Compra
        </h3>
      <>
        {cart.map((product) => (
          <>
            <div className="card" key={product.id}>
              <div className="card_img">
                <img src={product.thumb} alt="" />
              </div>
              <div className="card_header">
                <h2>{product.name}</h2>
                <span>
                  Quantidade:
                  <p
                    onClick={() => cartDecrement(product)}
                  ></p>
                  <p className="price">
                    {product.quantity === 0
                      ? removeProduct(product)
                      : product.quantity}
                  </p>
                </span>
              </div>
              <p className="price">
                {" "}
                Total R$ {product.price * product.quantity}
              </p>
              <div className="btn card_header" onClick={() => removeProduct(product)}>
                Remover
              </div>
            </div>
          </>
        ))}
      </>
      
      <div className="card">
        <h2 className="compra">Seu Cofre</h2>
        
        <div className="card_header">
          <p className="price">
            {cart.reduce((acc, item) => acc + item.quantity, 0) === 1
              ? `1 produto`
              : `${cart.reduce(
                  (acc, item) => acc + item.quantity,
                  0
                )} produtos`}
          </p>
          <p className="price">
            R$ {cart.reduce((acc, item) => acc + item.quantity * item.price, 0)}
            </p>
            <div className=" btn ">Finalizar Pedido</div>
         
        </div>
        <div className="btn card_header" onClick={() => history.push("/")}>
          <p><strong>Continuar Comprando</strong></p>
        </div>
      </div>
    </div>
  );
};
